import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  DropdownButton,
  Dropdown,
  Image,
  Table,
  FormControl,
} from "react-bootstrap";
import { getLesson } from "./../apis/tutors";
import Lessonrequirements from "./TutorRequestFlow/Lesson/LessonRequirements";
import Lessonsummary from "./TutorRequestFlow/Lesson/LessonSummary";
import Questions from "./TutorRequestFlow/Lesson/Questions";
import { AcceptLessonModal } from "./TutorRequestFlow/Modals/AcceptLessonModal";
import { InitialDeclinePageModal } from "./TutorRequestFlow/Modals/InitialDeclinePageModal";
import { ProvideNewOfferModal } from "./TutorRequestFlow/Modals/ProvideNewOfferModal";
import { NewOfferForm } from "./TutorRequestFlow/Modals/NewOfferForm";
import { ReasonLessonModal } from "./TutorRequestFlow/Modals/ReasonLessonModal";

class Lesson extends Component {
  constructor() {
    super();

    this.state = {
      AllLesson: [],
      dummayData: [
        {
          status: "Confirmed",
          lessonNo: "2 out of 10",
          student: "Mawuli A.",
          sessionType: "Online",
          day: "Monday",
          time: "17:00PM - 18:00PM",
          booked: "30jan 2020",
          subject: "GCSE Maths",
          detail: "Lorem Ipsum is simply dummy. ",
          earningAmount: "$60.00",
        },
        {
          status: "Cancelled",
          lessonNo: "3 out of 5",
          student: "Mawuli A.",
          sessionType: "Online",
          day: "Monday",
          time: "17:00PM - 18:00PM",
          booked: "30jan 2020",
          subject: "GCSE Maths",
          detail: "Lorem Ipsum is simply dummy.",
          earningAmount: "$160.00",
        },
        {
          status: "Confirmed",
          lessonNo: "2 out of 10",
          student: "Mawuli A.",
          sessionType: "Online",
          day: "Monday",
          time: "17:00PM - 18:00PM",
          booked: "30jan 2020",
          subject: "GCSE Maths",
          detail: "Lorem Ipsum is simply dummy.",
          earningAmount: "$180.00",
        },
      ],
      selectedBtn: "Request",
      isOpen: false,
      InitialDeclineModal: false,
    };
  }

  // getLesson
  getAllLesson = (data) => {
    getLesson({ token: data.token, id: data.id })
      .then((res) => {
        this.setState({
          AllLesson: res.data,
        });
      })
      .catch((err) =>
        this.setState({
          error: err,
        })
      );
  };
  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;

    // getLesson
    this.getAllLesson({ id: "1234", token });
  };
  nameFirstChar = (name) => {
    return (name = name.charAt(0));
  };
  render() {
    const {
      selectedBtn,
      AllLesson,
      isOpen,
      InitialDeclineModal,
      reason,
      offer,
      newOfferModal,
      offerFormModal,
      startDate,
      time,
      timeStatus,
      lessonDuration,
      lessonRate,
      location,
      LessonFrequency,
    } = this.state;
    return (
      <div className="container">
        <div className="Lesson-Col">
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <div className="flex-between-center name-head">
                <div className="text-bold">Jonathan</div>
                <div className="Rectangle-775 text-bold flex-center-center">
                  Book lesson
                </div>
              </div>
              <div className="flex-col-center">
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <AlertTextPanel
                  message={`To protect your lessons and payments, always communicate and pay through 
                Askademia website`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <MessageTextPanel
                  message={`Hi Christopher, I am looking forward to solving. This hard GCSE maths 
                with you for a school project.I don not understand the concept but I 
                know you can help me with it and I am really counting on you because 
                you have some excellent.`}
                  userName={"Jonathan"}
                  time={"09:58"}
                />
                <AlertTextPanel
                  message={`Jonathan's lesson details : Mon 14 May at 9:00 AM - 10:00 AM`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <AlertTextPanel
                  message={`Jonathan's lesson details : Mon 14 May at 9:00 AM - 10:00 AM`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <AlertTextPanel
                  message={`Reminder - Request expires in 5 hours`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <AlertTextPanel
                  message={`Lesson Confimed`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <MessageTextPanel
                  message={`Hi Christopher, I am looking forward to solving. This hard GCSE maths 
                with you for a school project.I don not understand the concept but I 
                know you can help me with it and I am really counting on you because 
                you have some excellent.`}
                  userName={"Christopher"}
                  time={"09:58"}
                  userIcon={require("./../assets/images/team5.png")}
                />
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <MessageTextPanel
                  message={`Hi Christopher, I am looking forward to solving.`}
                  userName={"Christopher"}
                  time={"09:58"}
                  userIcon={require("./../assets/images/team5.png")}
                />
                <div
                  className="text-bold"
                  style={{
                    fontSize: "12px",
                    color: "#1c1c1c",
                    margin: "20px 0px",
                  }}
                >
                  10 Mar 2020
                </div>
                <AlertTextPanel
                  message={`Your next lesson is Mon,21st May 2020`}
                  imgIcon={require("./../assets/icons/comment.png")}
                  time={"09:58"}
                />
                <div className="flex-center text-message-area">
                  <div className="grey-box flex-center-center">
                    <div className="box-inner flex-center-center">+</div>
                  </div>
                  <FormControl type="text" placeholder="Type a message" />
                </div>
              </div>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12} className="right-side-panel">
              <div className="user-sub-detail-card flex-between-center">
                <div>
                  <div className="status">CANCELLED</div>
                  <div className="name">Mawuli</div>
                  <div className="normal-para">Maths (GCSE) . £20 per lesson</div>
                </div>
                <div className="Ellipse-134 flex-center-center">{"M"}</div>
              </div>
              <div className="flex info-div-P">
                <div className="info-div flex-col-center">
                  <div>Start date</div>
                  <div>Mon 14 May (Weekly)</div>
                </div>
                <div className="info-div flex-col-center">
                  <div>Time</div>
                  <div>9:00AM - 10:00AM</div>
                </div>
                <div className="info-div flex-col-center">
                  <div>Location</div>
                  <div>Online classroom</div>
                </div>
                <div className="info-div flex-col-center">
                  <div>Price</div>
                  <div>£20 per lesson</div>
                </div>
              </div>
              <hr />
              <Lessonrequirements
                AcceptLessonModalOpen={() =>
                  this.setState({
                    isOpen: true,
                  })
                }
                InitialDeclineModalOpen={() =>
                  this.setState({
                    InitialDeclineModal: true,
                  })
                }
              />
              <Lessonsummary />
              <Questions />
            </Col>
          </Row>
          <AcceptLessonModal
            isOpen={isOpen}
            onHide={() =>
              this.setState({
                isOpen: false,
              })
            }
            Accept={() => {
              this.props.history.push('/tutor-dashboard/lessonDetails')
            }}
          />
          <InitialDeclinePageModal
            isOpen={InitialDeclineModal}
            onHide={() =>
              this.setState({
                InitialDeclineModal: false,
              })
            }
            reason={reason}
            selectReason={(text, i) => {
              this.setState({
                reason: i,
              });
            }}
            nextButton={() => {
              this.setState({
                InitialDeclineModal: false,
                newOfferModal: true,
              });
            }}
          />

          <ReasonLessonModal
            isOpen={false}
            onHide={() =>
              this.setState({
                isOpen: false,
              })
            }
            Accept={() => {
              console.log("====");
            }}
          />
          <ProvideNewOfferModal
            isOpen={newOfferModal}
            onHide={() =>
              this.setState({
                newOfferModal: false,
              })
            }
            offer={offer}
            selectOffer={(text, i) => {
              this.setState({
                offer: i,
              });
            }}
            nextButton={() =>
              offer === 0
                ? this.setState({
                    offerFormModal: true,
                    newOfferModal: false,
                  })
                : this.setState({
                    newOfferModal: false,
                  })
            }
          />
          <NewOfferForm
            isOpen={offerFormModal}
            onHide={() =>
              this.setState({
                offerFormModal: false,
              })
            }
            onSelect={(value, name) =>
              this.setState({
                [name]: value,
              })
            }
            onChange={(e) =>
              this.setState({
                lessonRate: e.target.value,
              })
            }
            lessonRat={lessonRate}
            startDate={startDate}
            timeStatus={timeStatus}
            time={time}
            location={location}
            lessonDuration={lessonDuration}
            LessonFrequency={LessonFrequency}
          />
        </div>        
      </div>

      // <div className="Lesson-Col">
      //   <Row>
      //     <Col lg={12} md={12} sm={12} xs={12}>
      //       <div className="header">
      //         <h2>Lessons</h2>
      //       </div>
      //       <div className="session-div">
      //         <h5>All sessions from</h5>
      //         <Row lg={12} md={12} sm={12} xs={12}>
      //           <Col
      //             lg={9}
      //             md={9}
      //             sm={9}
      //             xs={12}
      //             className="flex-center btns-section"
      //           >
      //             <Button
      //               className={selectedBtn === "Request" ? "activebtn" : ""}
      //               onClick={() => this.setState({selectedBtn: "Request"})}
      //             >
      //               Request
      //             </Button>
      //             <Button
      //               className={selectedBtn === "Upcoming" ? "activebtn" : ""}
      //               onClick={() => this.setState({selectedBtn: "Upcoming"})}
      //             >
      //               Upcoming
      //             </Button>
      //             <Button
      //               className={selectedBtn === "Cancelled" ? "activebtn" : ""}
      //               onClick={() => this.setState({selectedBtn: "Cancelled"})}
      //             >
      //               Cancelled
      //             </Button>
      //             <Button
      //               className={selectedBtn === "Declined" ? "activebtn" : ""}
      //               onClick={() => this.setState({selectedBtn: "Declined"})}
      //             >
      //               Declined
      //             </Button>
      //             <Button
      //               className={selectedBtn === "Completed" ? "activebtn" : ""}
      //               onClick={() => this.setState({selectedBtn: "Completed"})}
      //             >
      //               Completed
      //             </Button>
      //           </Col>
      //           <Col lg={3} md={3} sm={3} xs={12} className="dropdown-btn-Col">
      //             <DropdownButton
      //               id="dropdown-basic-button downloads-dropdown"
      //               title={
      //                 <span>
      //                   Downloads
      //                   <span className="border"/>
      //                 </span>
      //               }
      //             >
      //               <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
      //               <Dropdown.Item href="#/action-2">
      //                 Another action
      //               </Dropdown.Item>
      //               <Dropdown.Item href="#/action-3">
      //                 Something else
      //               </Dropdown.Item>
      //             </DropdownButton>
      //           </Col>
      //           <Col lg={12} md={12} sm={12} xs={12} className="Search-Col">
      //             <Col className="search-Col2 flex-center">
      //               <DropdownButton
      //                 id="dropdown-basic-button"
      //                 title={
      //                   <span>
      //                     <span style={{fontSize: "18px"}}>Search Date</span>
      //                     <Image
      //                       style={{width: "15px", marginLeft: "20px"}}
      //                       src={require("./../assets/icons/down-arrow.png")}
      //                     />
      //                   </span>
      //                 }
      //               >
      //                 <Dropdown.Item href="#/action-1">
      //                   Search Date
      //                 </Dropdown.Item>
      //                 <Dropdown.Item href="#/action-2">
      //                   Another action
      //                 </Dropdown.Item>
      //               </DropdownButton>
      //               <div className="truncate" style={{fontWeight: "bold"}}>
      //                 Lessons booked can be rescheduled or cancelled
      //               </div>
      //             </Col>
      //           </Col>
      //           <Col lg={12} md={12} sm={12} xs={12}>
      //             <Table borderless responsive className="table-parent">
      //               <thead>
      //               <tr>
      //                 <th className="tabel-head">Status</th>
      //                 <th className="tabel-head">Lesson number</th>
      //                 <th className="tabel-head">Students</th>
      //                 {/* <th className="tabel-head">Lesson type</th> */}
      //                 <th className="tabel-head">Day</th>
      //                 <th className="tabel-head">Time</th>
      //                 {/* <th className="tabel-head">Booked</th> */}
      //                 <th className="tabel-head">Subject</th>
      //                 <th
      //                   className="tabel-head"
      //                   style={{maxWidth: "270px"}}
      //                 >
      //                   Detail
      //                 </th>
      //                 <th className="tabel-head">Earning to date</th>
      //                 <th className="tabel-head"></th>
      //                 <th className="tabel-head"></th>
      //               </tr>
      //               </thead>
      //               <tbody>
      //               {AllLesson?.length &&
      //               AllLesson.map((value, index) => (
      //                 <tr key={index}>
      //                   <td
      //                     className={`tabel-data ${
      //                       value.status === "Confirmed" ? "" : ""
      //                     }`}
      //                   >
      //                       {
      //                         value.status ?
      //                         <span>
      //                           {value.status}
      //                         </span> : "NILL"

      //                       }
      //                   </td>
      //                   <td className="tabel-data">{value.lessonNo}</td>
      //                   <td className="tabel-data d-flex justify-content-start align-items-center" style={{width: "150px"}}>
      //                     <div>
      //                     {
      //                         value?.student ?
      //                         <h2 className="circle">{this.nameFirstChar(value?.student)}</h2>
      //                         : <h2 className="circle">?</h2>
      //                     }
      //                     </div>
      //                    {value.student}</td>
      //                   {/* <td className="tabel-data">{value.sessionType}</td> */}
      //                   <td className="tabel-data">{value.day}</td>
      //                   <td className="tabel-data">{value.time}</td>
      //                   {/* <td className="tabel-data">{value.booked}</td> */}
      //                   <td className="tabel-data">{value.subject}</td>
      //                   <td
      //                     className="tabel-data"
      //                     style={{width: "200px"}}
      //                   >
      //                     <span>{value.detail}</span>
      //                   </td>
      //                   <td className="tabel-data">
      //                     {value.earningAmount}
      //                   </td>
      //                   <td className="tabel-data">
      //                     <Button>Details</Button>
      //                   </td>
      //                   <td
      //                     className="tabel-data"
      //                     style={{paddingLeft: "0px"}}
      //                   >
      //                     <Button>Contact</Button>
      //                   </td>
      //                 </tr>
      //               ))}
      //               </tbody>
      //             </Table>
      //           </Col>
      //         </Row>
      //       </div>
      //     </Col>
      //   </Row>
      // </div>
    );
  }
}
const AlertTextPanel = ({ message, imgIcon, time }) => {
  return (
    <div className="Alert-panel">
      <Image
        src={imgIcon}
        style={{
          width: "16.5px",
          height: "14.8px",
          marginRight: "5px",
        }}
      />
      |
      <div
        style={{
          marginLeft: "5px",
        }}
      >
        {message}
        <span className="time">{time}</span>
      </div>
    </div>
  );
};
const MessageTextPanel = ({ message, userName, userIcon, time }) => {
  return (
    <div className="message-panel">
      <div className="flex">
        <div className="Ellipse-134 flex-center-center">
          {userIcon ? (
            <Image
              src={userIcon}
              roundedCircle
              style={{ width: "100%", height: "100%" }}
            />
          ) : (
            userName.charAt(0)
          )}{" "}
        </div>
        <div
          style={{
            marginLeft: "5px",
          }}
          className="user-name"
        >
          {userName}
          <span className="time">{time}</span>
        </div>
      </div>
      <div
        className="common-para"
        style={{
          marginLeft: "35px",
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default Lesson;
